import api from "@/apis/TransactionAPI";
import Crud from "./crud-base";
import httpClient from "@/apis/base/axios-httpclient";
// import stateOverride from '@/stores/transaction/module-transaction-state';
// import mutationsOverride from '@/stores/transaction/module-transaction-mutations';
// import actionsOverride from '@/stores/transaction/module-transaction-actions';
// import gettersOverride from '@/stores/transaction/module-transaction-getters';
var crud = new Crud("transactions", api);

const state = {
  ...crud.state,
  //...stateOverride,
  _config: {
    field: {
      key: "code",
      code: "name",
      name: "name",
    },
  },
  datas: [],
  // Tổng số tiền hiển thị
  totalFeeAmount: 0,
  totalOrderAmount: 0,
  totalPaymentAmount: 0,
};
const getters = {
  ...crud.getters,
  //...gettersOverride
};
const actions = {
  ...crud.actions,
  //...actionsOverride,
  /**
   *  Load danh sách
   */
  async load(context, payload) {
    let res = null;
    try {
      context.commit("updateLoading", true);
      res = await api.getList(payload || {});
    } finally {
      context.commit("updateLoading", false);
    }

    if (res && !payload.notUpdateItem) {
      context.commit("setItems", { result: res, payload: payload });
    } else {
      context.commit("setDatas", { result: res, payload: payload });
    }
    context.commit("SET_TRANSACTIONS", res);
    // context.commit('TOTAL_AMOUNT');
    return res;
  },

  async loadSummary(context, payload) {
    let res = null;
    try {
      context.commit("updateLoadingSummary", true);
      res = await api.getList(payload || {});
    } finally {
      context.commit("updateLoadingSummary", false);
    }
    if (res) {
      //Nếu lấy toàn bộ dữ liệu
      // context.commit('SET_TRANSACTIONS', res);
      // context.commit('TOTAL_AMOUNT');
    }
  },
};
const mutations = {
  ...crud.mutations,
  // ...mutationsOverride,
  setDatas(state, data) {
    if (data.result) {
      if (data.result.length > 0) {
        state.datas.removeAll();
        state.datas = data.result;
        //state.dataTotal = resultValue;
      }
    }
  },

  SET_TRANSACTIONS(state, transactions) {
    state.totalOrderAmount = transactions.customData?.totalOrderAmount;
    state.totalFeeAmount = transactions.customData?.totalFeeAmount;
    state.totalPaymentAmount = transactions.customData?.totalPaymentAmount;
  },
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
